import { featuredWorks } from "@/mocks/doujinshi";
import WorkCard from "./WorkCard";

export default function FeaturedSection() {
  return (
    <section
      id="featured"
      className="w-full bg-background-900/60 py-16 md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-accent-400">
              <i className="ri-star-fill"></i>
              FEATURED
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              精选作品推荐
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
              编辑部从各IP中甄选的高人气同人佳作，涵盖燃向战斗、治愈日常与热血竞技等多元题材。
            </p>
          </div>
          <a
            href="#latest"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/40 px-4 py-2 text-sm font-medium text-foreground-500 transition-colors hover:border-accent-400/50 hover:text-accent-300"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div
          className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3"
          data-product-shop
        >
          {featuredWorks.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}